import {
    CreateRegulationState,
    CreateRegulationTypes,
    SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED,
    SET_HOVERED_SEGMENT_TO_BE_CREATED,
    SET_SEGMENTS_TO_BE_CREATED,
    TOGGLE_CREATE_REGULATION_PANEL,
    TOGGLE_CREATE_OPTIONS_PANEL,
    TOGGLE_DRAW_CUSTOM_GROUP,
    IS_TOAST_POPUP_ENABLED,
    IS_TOAST_POPUP_ENABLED_TWO,
    IS_TOAST_POPUP_ENABLED_THREE,
    IS_TOAST_POPUP_ENABLED_FOUR,
    CREATED_REGULATION_RECEIVED,
    STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS,
    STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS,
    CREATE_PROPOSED_LINK,
    PROPOSED_LINK_CREATED,
    RECEIVED_DIVIDED_LINK,
    STORE_ADJACENT_LINKS,
    STORE_PROPOSED_ADJACENT_LINKS,
    TOGGLE_PROJECT_PANEL
} from "../../actions/regulation/CreateRegulation/types";
import { isDictionaryEmpty } from "../../Utilities/generalUtilities";
import { defaultProposedLinkRecord } from "../../interfaces/ProposedLink";
import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: CreateRegulationState = {
    isCreateRegulationPanelOpen: false,
    isCreateOptionsPanelOpen: false,
    isDrawCustomGroupEnabled: false,
    isToastPopupEnabled: false,
    isToastPopupEnabledTwo: false,
    isToastPopupEnabledThree: false,
    isToastPopupEnabledFour: false,
    segmentsToBeCreated: {},
    hoveredSegmentToBeCreated: {},
    customGroupSegmentsToBeHighlighted: {},
    createdRegulationData: false,
    toBeCreatedCustomGroupSegments: {},
    toBeConfirmedCustomGroupSegments: new Map(),
    proposedLinkCreatedData: defaultProposedLinkRecord,
    proposedLinkToCreate: defaultProposedLinkRecord,
    dividedLinkData: null,
    adjacentLinks: null,
    proposedAdjacentLinks: null,
    isProjectPanelOpen: true
};
const CreateRegulation = (
    state = initialState,
    action: CreateRegulationTypes
): CreateRegulationState => {
    switch (action.type) {
        case TOGGLE_CREATE_REGULATION_PANEL: {
            return {
                ...state,
                isCreateRegulationPanelOpen: action.payload.isCreateRegulationPanelOpen,
                isDrawCustomGroupEnabled: false
            };
        }
        case TOGGLE_CREATE_OPTIONS_PANEL: {
            return {
                ...state,
                isCreateOptionsPanelOpen: action.payload.isCreateOptionsPanelOpen,
                isDrawCustomGroupEnabled: false
            };
        }
        case TOGGLE_PROJECT_PANEL: {
            return {
                ...state,
                isProjectPanelOpen: action.payload.isProjectPanelOpen
            };
        }
        case TOGGLE_DRAW_CUSTOM_GROUP: {
            return {
                ...state,
                isDrawCustomGroupEnabled: action.payload.isDrawCustomGroupEnabled
            };
        }

        case IS_TOAST_POPUP_ENABLED: {
            return {
                ...state,
                isToastPopupEnabled: action.payload.isToastPopupEnabled
            };
        }
        case IS_TOAST_POPUP_ENABLED_TWO: {
            return {
                ...state,
                isToastPopupEnabledTwo: action.payload.isToastPopupTwoEnabled
            };
        }

        case IS_TOAST_POPUP_ENABLED_THREE: {
            return {
                ...state,
                isToastPopupEnabledThree: action.payload.isToastPopupThreeEnabled
            };
        }
        case IS_TOAST_POPUP_ENABLED_FOUR: {
            return {
                ...state,
                isToastPopupEnabledFour: action.payload.isToastPopupFourEnabled
            };
        }

        case SET_SEGMENTS_TO_BE_CREATED: {
            return {
                ...state,
                segmentsToBeCreated: action.payload.segmentsToBeCreated
            };
        }
        case SET_HOVERED_SEGMENT_TO_BE_CREATED: {
            return {
                ...state,
                hoveredSegmentToBeCreated: action.payload.hoveredSegmentToBeCreated
            };
        }
        case SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED: {
            if (isDictionaryEmpty(action.payload.customGroupSegmentsToBeHighlighted)) {
                return {
                    ...state,
                    customGroupSegmentsToBeHighlighted:
                        action.payload.customGroupSegmentsToBeHighlighted,
                    isDrawCustomGroupEnabled: false
                };
            }
            return {
                ...state,
                customGroupSegmentsToBeHighlighted:
                    action.payload.customGroupSegmentsToBeHighlighted
            };
        }
        case CREATED_REGULATION_RECEIVED: {
            return {
                ...state,
                createdRegulationData: action.payload.data
            };
        }
        case STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS: {
            return {
                ...state,
                toBeCreatedCustomGroupSegments: action.payload.toBeCreatedCustomGroupSegments
            };
        }
        case STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS: {
            return {
                ...state,
                toBeConfirmedCustomGroupSegments: action.payload.toBeConfirmedCustomGroupSegments
            };
        }
        case CREATE_PROPOSED_LINK: {
            return {
                ...state,
                proposedLinkToCreate: action.payload.proposedLinkToCreate
            };
        }
        case PROPOSED_LINK_CREATED: {
            return {
                ...state,
                proposedLinkCreatedData: action.payload.proposedLinkCreatedData
            };
        }
        case RECEIVED_DIVIDED_LINK: {
            return {
                ...state,
                dividedLinkData: action.payload.data
            };
        }
        case STORE_ADJACENT_LINKS: {
            return {
                ...state,
                adjacentLinks: action.payload.data
            };
        }
        case STORE_PROPOSED_ADJACENT_LINKS: {
            return {
                ...state,
                proposedAdjacentLinks: action.payload.data
            };
        }
        case RESET_STATE: {
            return {
                ...initialState
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default CreateRegulation;
